import { useIdentifyUser } from 'api';
import { AppProviders, ErrorDetails, useIdentifyNativeShell } from 'features';
import { APIProvider } from 'form';
import { ErrorBoundary } from 'react-error-boundary';
import { Router } from './Router';

const GOOGLE_MAPS_API_KEY = 'AIzaSyACa__1i4lx3lWZGWu6lJFFcY7TH7qDfxI';

export const App = () => {
  useIdentifyUser();
  useIdentifyNativeShell();

  return (
    <ErrorBoundary fallbackRender={({ error }) => <ErrorDetails error={error} />}>
      <AppProviders>
        <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
          <Router />
        </APIProvider>
      </AppProviders>
    </ErrorBoundary>
  );
};
